import React, { useEffect, useRef, useState } from 'react';
import { InputGroup, FormControl, Badge } from 'react-bootstrap';
import './InputFieldWithCreateAndVerify.css';
import Button from '../../../pages/AppWrapperViewComponent/OverView/Button';
import InfoBar from '../InfoBars';
import { buttonNames } from '@constants/appConstants';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/reducers';
import CreateAndVerifyModal from '@pages/Beneficiary-block/WomenComponent/Child/CreateAndVerifyModal';
import { useDispatch } from 'react-redux';
import { updateChild, updateDeliveryDetails } from '@store/actions/beneficiaryAction';
import RegisterChildModal from '@pages/Beneficiary-block/WomenComponent/Child/RegisterChildModal';
import AbhaChildModal from '@pages/Beneficiary-block/WomenComponent/Child/AbhaChildModal';

interface Inputwithlabelprops {
  inputwithlabelPlaceholder: string;
  inputlabelPlaceholder: string;
  labelName?: string;
  inputlabeltype: string;
  inputlabelvalue?: any;
  disabled: boolean;
  verified: boolean;
  id: string;
  onChange: (value: string | boolean) => void;
  value?: any;
  required?: boolean,
  errorMessage?: string;
  inputType?: string;
  verifyMessage?: string;
  onClickVerify?: (value: boolean) => void;
  flow?: string;
}
const InputFieldWithCreateAndVerify = ({
  inputwithlabelPlaceholder,
  inputlabelPlaceholder,
  labelName,
  inputlabeltype,
  inputlabelvalue,
  disabled,
  verified,
  required,
  id,
  onChange,
  errorMessage,
  inputType,
  verifyMessage,
  onClickVerify,
  flow,
}: Inputwithlabelprops) => {

  const inputlabelChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
    setVerify(false);
  }

  const dispatch = useDispatch()

  const [verify, setVerify] = useState<boolean>(false);
  const [displayVerify, setDisplayVerify] = useState<boolean>(false);
  const [displayNotVerify, setDisplayNotVerify] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [currFlow, setCurrFlow] = useState('');
  const [showChildAadhaarFlow, setShowChildAadhaarFlow] = useState<boolean>(false);
  const [showRegisterChildModal, setShowRegisterChildModal] = useState<boolean>(false);

  const createSubmitClicked = useSelector((state: RootState) => state.beneficiary.createSubmitClicked);
  const verifySubmitClicked = useSelector((state: RootState) => state.beneficiary.verifySubmitClicked);
  const childAbha = useSelector((state: RootState) => state.beneficiary.childBALAbhaId);
  const disableButton = childAbha.length !== 14;
  const createButtonRef = useRef<any>(null);
  const verifyButtonRef = useRef<any>();
  const dliveryChildLinkedButtonRef = useRef<any>();
  const clickedBtnName = useSelector((state: RootState) => state.beneficiary.clickedBtnName);


  useEffect(() => {
    if (verifySubmitClicked) {
      setVerify(true);
    }
    return () => {
      setVerify(false);
      dispatch(updateChild("childBALAbhaId", ''));
    };
  }, [verifySubmitClicked]);


  const handleOpenModalForDeliveryVerificationModal = () => {
    if (dliveryChildLinkedButtonRef.current) {
      const button = dliveryChildLinkedButtonRef.current.querySelector('button');
      dispatch(updateDeliveryDetails('clickedBtnName', button?.id));
    }
    setShowModal(true);
  };

  const handleRegistrationDiscard = () => {
    setShowRegisterChildModal(false);
  }

  const handleDetailsClick = (key: string, id:any, code:any) => {
    handleRegistrationDiscard();
    if(key === 'parent') {
      handleOpenModalForDeliveryVerificationModal();
      dispatch(updateChild('childRegistrationId', {key: code, id: id}));
    } else {
      setShowChildAadhaarFlow(true);
      dispatch(updateChild('isChildRegistration', true));
      dispatch(updateChild('childRegistrationId', {key: code, id: id}));
    }
  }

  const handleLinkClick = () => {
    if(flow === 'delivery') {
      handleOpenModalForDeliveryVerificationModal();
    } else {
      setShowRegisterChildModal(true);
      setShowChildAadhaarFlow(false);
      dispatch(updateChild('isChildRegistration', false));
    }
  }

  useEffect(() => {
    return () => setShowModal(false);
  }, []);

  useEffect(() => {
    if (verify === true && verified === true) {
      setDisplayVerify(true);
      setDisplayNotVerify(false);
    }
    else if (verify === true && verified === false) {
      setDisplayNotVerify(true);
      setDisplayVerify(false);
    }
    else {
      setDisplayNotVerify(false);
      setDisplayVerify(false);
    }
  })

  const handleCreateAndVerifyModalClose = (option?: string) => {
    setShowModal(false);
    if (option === 'back' && flow !== 'delivery') {
      setShowRegisterChildModal(true);
      dispatch(updateChild('isChildRegistration', false));
    }
  };

  const handleChildAdharBackFlow = () => {
    setShowRegisterChildModal(true);
    setShowChildAadhaarFlow(false)
    dispatch(updateChild('isChildRegistration', false));
  }

  return (
    <>
      <div className="ip-with-label">
        {labelName && (
          <label className={`label-name-required-for-ip ${required && 'yes'} `}>
            {labelName}
          </label>
        )}
        <div className="input-with-verify-button-main">
          <div className="input-with-button-verify">
            <InputGroup className="text-button-ip">
              <FormControl
                className="field-for-text-in-label"
                placeholder={inputwithlabelPlaceholder}
                onChange={inputlabelChange}
                type={inputlabeltype}
                value={inputlabelvalue}
                disabled={true}
              />
            </InputGroup>
            {displayVerify && verified && (
              <button className="verified-button-for-in-label" disabled={true}>
                {verified ? inputlabelPlaceholder : 'Not Verified'}
              </button>
            )}
            {displayNotVerify && verified === false && (
              <button
                className="verified-button-for-in-label-not-verified"
                disabled={true}
              >
                {verified ? inputlabelPlaceholder : 'Not Verified'}
              </button>
            )}
          </div>
            <>
              <div className={`abha_button_common_component`}
                ref={dliveryChildLinkedButtonRef}>
                <button
                  type="button"
                  onClick={handleLinkClick}
                  id={id}
                  className={`adding_the_dynamic_button primary`}
                  disabled={(flow !== 'delivery' && (verifySubmitClicked || createSubmitClicked)) || disabled}
                >{buttonNames.linkAbha}
                </button>
              </div>
            </>
        </div>
        <div className="input_field_infoBars">
          {inputType === 'success' ? (
            <InfoBar
              variant="success"
              message={errorMessage ? errorMessage : 'Success'}
              className="input_field_class"
            />
          ) : (
            ''
          )}
          {inputType === 'error' ? (
            <InfoBar
              variant="danger"
              message={errorMessage ? errorMessage : ''}
              className="input_field_class"
            />
          ) : (
            ''
          )}
        </div>


      </div>
      {showModal && <CreateAndVerifyModal
        showModal={showModal}
        handleClose={handleCreateAndVerifyModalClose}
      />}
      <RegisterChildModal 
        showModal={showRegisterChildModal} 
        handleDiscard={handleRegistrationDiscard}
        handleDetailsClick={handleDetailsClick}
      />
      {showChildAadhaarFlow && <AbhaChildModal
        showModal={showChildAadhaarFlow}
        handleBack={handleChildAdharBackFlow} 
      />
      }
    </>
  );
};
export default InputFieldWithCreateAndVerify;